/**
 * Clone an object using structured clone if available or JSON serialization if not.
 * @param obj The object to clone
 * @returns The cloned object
 */
export function clone<T>(obj: T): T {
  if (typeof obj === 'object' && obj !== null) {
    if (typeof window?.structuredClone === 'function') {
      return window.structuredClone(obj);
    }
    if (typeof (obj as any).clone === 'function') {
      return (obj as any).clone();
    }
    return JSON.parse(JSON.stringify(obj));
  } else {
    return obj;
  }
}
